export default {
    methods: {
        // sprawdza czy program aktualnie trwa, na podstawie daty rozpoczęcia i zakończenia programu
        isCurrent(start, end) {
            const currentTime = new Date().getTime();
            if (currentTime > start && currentTime < end) {
                return true;
            }
            return false;
        }
    }
};
